import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import axios from "axios";

import Entity from "../datasource/Entity";
import Reservations from "../components/Views/Reservations.jsx";
import SingleReservation from "../components/Views/SingleReservation.jsx";
import {
    DEFAULT_GET_PARAMS,
    SEARCH_FIELD_TYPES,
    SEARCH_ERROR_MSG,
} from "../lib/data";
import clientConfig from "../config/client";

class ReservationsContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("reservations");
        this.getAuxData();
        this.state = {
            ...this.state,
            loading: true,
            // getParams: { ...DEFAULT_GET_PARAMS }
            getParams: { ...this.globalSearch.search.reservations },
        };
    }

    getBackLinkToReservations = () => this.datasource.routes().home;


    handleSearchError = (errorResp) => {
        const locale = clientConfig.locale;
        const errorFieldsArr = Object.keys(errorResp.data);
        const errorFiledsLocaleLabels = [];

        for (const key of errorFieldsArr) {
            for (const searchEntity in SEARCH_FIELD_TYPES) {
                if (SEARCH_FIELD_TYPES[searchEntity].name === key) {
                    errorFiledsLocaleLabels.push(
                        `${SEARCH_FIELD_TYPES[searchEntity].label[locale]} - ${errorResp.data[key]} `,
                    );
                }
            }
        }

        const errorMsg =
            SEARCH_ERROR_MSG.label[locale] +
            "[" +
            errorFiledsLocaleLabels +
            "]";

        return alert(errorMsg);
    };

    getGuestData = (id, reservationId) => {
        axios.get(`/manager/data/guests/get_guest_data/${id}/${reservationId}`)
            .then(response => {
                this.setState({ curGuest: response.data })
            })
            .catch(error => {
                console.error('Error:', error.response?.data);
            });
    };

    // getRoomTypes = () => {
    //     const roomTypesEntity = new Entity(
    //         "room_types",
    //         this.props.baseEntity,
    //         this.props.match.params.mainId
    //     );
    //
    //     roomTypesEntity
    //         .getAll()
    //         .then(response => this.setState({ roomTypes: response }))
    //         .catch(e => {
    //             alert("Ошибка получения типов номеров!");
    //             throw new Error(e);
    //         });
    // };

    getPaymentTypeNames = () => {
        const paymentMethodsEntity = new Entity(
            "payment_methods",
            this.props.baseEntity,
            this.props.match.params.mainId,
        );

        paymentMethodsEntity
            .getAll()
            .then((res) => {
                if (Array.isArray(res)) {
                    const paymentTypeNames = res.map((method) => ({
                        name: method.name,
                        id: method.id,
                    }));

                    this.setState({
                        paymentTypeNames: paymentTypeNames,
                    });
                }
            })
            .catch((e) => {
                alert("Ошибка получения способов оплаты!");
                throw new Error(e);
            });
    };

    setNewResStatus = () => {

        const {
            cancel_reason,
            status,
            id,
            hotel_id: hotelId,
            external_id,
            new_payment
        } = {
            ...this.state.currentItem,
        };

        let comment

        if(status === 'cancelled' && cancel_reason) {
            comment = cancel_reason;
        } else {
            comment = prompt("Укажите причину изменения статуса.");

            if (comment === "") {
                alert("Не указана причина изменения статуса");
                return false;
            }
            if (!comment) return false;
        }

        let ignoreNonRefundable = false;

        const updateStatus = () => {
            this.datasource
                .updateOne({ status, id, hotelId, comment, ignoreNonRefundable, external_id, new_payment })
                .then((res) => {
                    alert(res.data.message);
                    this.props.history.push(this.datasource.routes().home);
                })
                .catch((err) => {
                    if (err?.response?.data?.status) {
                        if (confirm(err.response.data.status[0])) {
                            ignoreNonRefundable = true;
                            updateStatus();
                        }
                    } else {
                        alert(err.response.data.message);
                    }
                });
        };

        updateStatus();
    };

    getAll = (params = {}) => {
        const path = this.datasource.dataPath + "/" + this.modelName;

        return axios.get(path, { params }).then((response) => response.data);
    };

    getAllItems = (params) =>
        this.getAll(params)
            .then((resData) =>
                this.setState({
                    AllItems: resData.data,
                    currentPage: resData.current_page,
                    firstPageUrl: resData.first_page_url,
                    from: resData.from,
                    loading: false,
                    lastPage: resData.last_page,
                    lastPageUrl: resData.last_page_url,
                    nextPageUrl: resData.next_page_url,
                    path: resData.path,
                    perPage: resData.per_page,
                    prevPageUrl: resData.prev_page_url,
                    to: resData.to,
                    total: resData.total,
                }),
            )
            .catch((error) => {
                this.handleSearchError(error.response);
            });

    paramsChangeHandler = (newParams) => this.getAllItems(newParams);
    setCustomLoading = (loading) =>
        this.setState((state) => ({ ...state, loading: loading }));

    render = () => {
        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relationsDataSource = this.datasource.relations;

        const auxDataRoomTypes = this.props?.auxData && this.props.auxData.room_types;
        const auxDataRates = this.props?.auxData && this.props.auxData.rates;
        const auxDataRefunds = this.props?.auxData && this.props.auxData.refund;

        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }
        return (
            <Switch>
                <Route path={routes.home} exact>
                    <Reservations
                        title={"Заявки на бронирование"}
                        getAllItems={this.getAllItems}
                        editAction={this.getEditLink}
                        roomTypes={auxDataRoomTypes}
                        rates={auxDataRates}
                        reservationsData={this.state}
                        fields={fields}
                        paramsChangeHandler={this.paramsChangeHandler}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        hotelId={this.props.match.params.mainId}
                        setLoading={this.setCustomLoading}
                        user={this.props.user}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <SingleReservation
                        initAction={this.getItem}
                        getBackLink={this.getBackLink}
                        pickedReservation={this.state.currentItem}
                        fields={fields}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <SingleReservation
                        initAction={this.getItem}
                        getBackLink={this.getBackLinkToReservations}
                        pickedReservation={this.state.currentItem}
                        submitAction={this.setNewResStatus}
                        fieldUpdateHandler={this.setFieldValue}
                        relationsDataSource={relationsDataSource}
                        getPaymentTypeNames={this.getPaymentTypeNames}
                        paymentTypeNames={this.state.paymentTypeNames}
                        fields={fields}
                        editable={true}
                        getGuestData={this.getGuestData}
                        curGuest={this.state.curGuest}
                        rates={auxDataRates}
                        roomTypes={auxDataRoomTypes}
                        refunds={auxDataRefunds}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                    />
                </Route>
            </Switch>
        );
    };
}

export default ReservationsContainer;
